import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import BigModal from '../../../../components/Modals/BigModal'
import EditAccess from './EditAccess'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const PTSAccess = () => {
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [employees, setEmployees] = useState([])
  const [openEdit, setOpenEdit] = useState(false)

  const loadList = () => {
    API.get('/company-settings-pts-permissions')
      .then((res) => {
        if (res.status === 200) {
          setEmployees(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }

  useEffect(() => loadList(), [])

  const coordinators = {
    title: 'CoOrdinators',
    employees: employees.filter((x) =>
      (x?.ptsAccess || []).includes('CoOrdinator')
    ),
    color: 'anPurple.main',
  }

  return (
    <Stack gap={1}>
      <Typography variant="title2">PTS Access</Typography>
      <Typography variant="body2" color="text.secondary">
        Every employee can be rostered onto a PTS duty. Co-Ordinators
        additionally get the bookings, planning and dispatch screens.
      </Typography>
      {loading && <LinearProgress />}
      <Button
        variant="contained"
        size="small"
        fullWidth
        onClick={() => setOpenEdit(true)}
      >
        Update Permissions
      </Button>
      <Grid container spacing={2}>
        {[coordinators].map((x) => (
          <Grid item xs={12} key={x.title}>
            <Box border="solid 2px" borderRadius="2px" borderColor={x.color}>
              <Stack>
                <Box
                  paddingX={2}
                  paddingY={1}
                  bgcolor={x.color}
                  display="flex"
                  justifyContent="center"
                >
                  <Typography variant="title3" color="white">
                    {x.title}
                  </Typography>
                </Box>
                <Box
                  paddingX={2}
                  paddingY={1}
                  display="flex"
                  flexDirection="column"
                >
                  {(x?.employees || []).map((emp) => (
                    <Box display="flex" gap={1} key={emp._id}>
                      <Avatar
                        src={emp.userAccount.photograph}
                        sx={{ height: 24, width: 24 }}
                      />
                      <Typography>
                        {emp.userAccount.firstName} {emp.userAccount.lastName}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Stack>
            </Box>
          </Grid>
        ))}
      </Grid>
      <BigModal open={openEdit} onClose={() => setOpenEdit(false)}>
        <EditAccess loadList={loadList} onClose={() => setOpenEdit(false)} />
      </BigModal>
    </Stack>
  )
}

export default PTSAccess
